const { default: axiosIns } = require('@/libs/axios')

const PropertyStatisticsService = {
  // GET - PropertyStatisticsApiController
  async getEarningsDashboard(accountId) {
    return axiosIns.get(`/properties/earnings?accountId=${accountId}`).then(response => response.data)
  },
  // POST - PropertyStatisticsApiController
  async getEarningStats(model, accountId) {
    return axiosIns.post(`/properties/statistics/earning?accountId=${accountId}`, model).then(response => response.data)
  },
  async getSummaryStats(model, accountId) {
    return axiosIns.post(`/properties/statistics/summary?accountId=${accountId}`, model).then(response => response.data)
  },
  async getChartStats(model, accountId) {
    return axiosIns.post(`/properties/statistics/chart?accountId=${accountId}`, model).then(response => response.data)
  },
  async getPlacementStats(model, accountId) {
    return axiosIns.post(`/properties/statistics/placement?accountId=${accountId}`, model).then(response => response.data)
  },
}

export default PropertyStatisticsService
